<template>
  <div class="container">
    <div class="comTop flex">
      <div class="flex topBox" style="width:45%">
        <div class="flex imgBox">
          <img class="fd" src="~images/index/lndn/top1.png" alt="" />
          <img class="dz" src="~images/index/lndn/dz.png" alt="" />
        </div>
        <div class="msgBox">
          <p style="color:#00FEDD">
            <span class="num">{{ sjObj.value }}</span
            >(户)
          </p>
          <p>{{ sjObj.name }}</p>
        </div>
      </div>
      <div class="flex topBox" style="width:55%">
        <div class="flex imgBox">
          <img class="fd" src="~images/index/lndn/top2.png" alt="" />
          <img class="dz" src="~images/index/lndn/dz.png" alt="" />
        </div>
        <div class="msgBox">
          <p style="color:#00FEDD">
            <span class="num">{{ srObj.value }}</span
            >(元/年)
          </p>
          <p>{{ srObj.name }}</p>
        </div>
      </div>
    </div>
    <div class="comBot flex">
      <div class="comleft">
        <div>
          <p>{{ fxObj.name }}</p>
          <p>
            <span class="num">{{ fxObj.value }}</span
            >(元/年)
          </p>
        </div>
        <div>
          <p>{{ spObj.name }}</p>
          <p>
            <span class="num">{{ spObj.value }}</span
            >(元/年)
          </p>
        </div>
      </div>
      <div class="chart" ref="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadLndnChart } from "../charts/lndnCharts";
import { mapGetters } from "vuex";
import { getOrgProcessGetLNDNALL2 } from "@/api/base";
export default {
  components: {},
  computed: {
    ...mapGetters([""])
  },
  data() {
    return {
      chart: null,
      sjObj: {
        name: "带动农户数",
        value: null
      },
      srObj: {
        name: "园内农户人均可支配收入",
        value: null
      },
      fxObj: {
        name: "园内农民人均可支配收入",
        value: null
      },
      spObj: {
        name: "园所在县农民人均可支配收入",
        value: null
      }
    };
  },
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);
      /* let data = {
        ddnh: 9915,
        ddnhFsx: 85,
        rjkzpsr: 26000,
        rjkzpsrCountry: 15000
      };
      this.sjObj.value = data.ddnh;
      this.srObj.value = data.rjkzpsr;
      this.fxObj.value = data.rjkzpsr;
      this.spObj.value = data.rjkzpsrCountry;
      loadLndnChart(this.chart, data.ddnhFsx); */

      getOrgProcessGetLNDNALL2().then(res => {
        let data = res.data;
        this.sjObj.value = data.ddnh;
        this.srObj.value = data.rjkzpsr;
        this.fxObj.value = data.rjkzpsr;
        this.spObj.value = data.rjkzpsrCountry;
        loadLndnChart(this.chart, data.ddnhFsx);
      });
    }
  },
  destoryed() {}
};
</script>
<style lang="stylus" scoped>
.container
  width 100%
  height 100%
.comTop
  justify-content space-around
  height 47.5%
  align-items flex-end
  padding-bottom: .15rem;
  box-sizing: border-box;
  width 90%
  margin 0 auto
.topBox
  position relative

  div
    margin-left .05rem
    height 100%
  p
    font-size .06rem

  span
    font-size .13rem

  .imgBox
    justify-content flex-end
    flex-direction column
    position relative
    width .4rem
  .msgBox
    width calc(100% - .4rem)
  .dz
    width 100%

  .fd
    width 100%
    position absolute
    z-index 1
    animation fudong 3s linear infinite
    left 50%
    transform translate(-50%,0%)

@keyframes fudong
  0%
    bottom 25%
  50%
    bottom 50%
  100%
    bottom 25%

.comBot
  height 47.5%
  display flex
  align-items center
  justify-content space-around
  width 90%
  margin 0 auto

  .comleft
    width 45%
    display flex
    justify-content space-around
    flex-direction column
    height 100%
    div
      background url('~images/index/lndn/listLine.png')
      background-size 100% 100%
      height 40%
      display flex
      justify-content center
      flex-direction column
      padding-left .15rem

      p
        color #fff
        font-size .06rem
      p:nth-child(2)
        padding-bottom .02rem
      span
        color #00FEDD
        font-size .1rem

  .chart
    width 30%
    height 100%
</style>
